module.exports = __webpack_public_path__ + "img/Logo_TF1Info_2023.fde121d4.png";